import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=ffd692da&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"
import style0 from "./forget.vue?vue&type=style&index=0&id=ffd692da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd692da",
  null
  
)

export default component.exports